import BFormFile from './form-file';
import { installFactory } from '../../utils/plugins';
var components = {
  BFormFile: BFormFile,
  BFile: BFormFile
};
export { BFormFile };
export default {
  install: installFactory({
    components: components
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-file/index.js
// module id = sN0L
// module chunks = 0